const ROWS = [
  {
    t: "Interaction signals",
    d: "Pointer paths, keystroke timing, scroll behaviour, and how long the form stayed open.",
  },
  {
    t: "Device traits",
    d: "Screen size, browser and platform strings, timezone, and rendering characteristics from canvas, WebGL, and audio.",
  },
  {
    t: "Proof of work",
    d: "Your browser solves a short computation before posting. It costs you about a second and costs a bot farm real money.",
  },
  {
    t: "Not collected",
    d: "What you type in the fields is never scored — only the timing around it. Nothing is sold, and nothing goes to an ad network.",
  },
];

export default function PrivacyDetail() {
  return (
    <section className="detail" id="privacy-detail" aria-labelledby="detail-h">
      <h2 className="eyebrow" id="detail-h">
        What we collect
      </h2>
      <dl className="detail__list">
        {ROWS.map((r) => (
          <div key={r.t}>
            <dt>{r.t}</dt>
            <dd>{r.d}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
